module.exports = __webpack_public_path__ + "img/white-logo.1d3bdd68.svg";